import { Action } from '@ngrx/store';

export enum InitAction {
  Load = '[Init] Load',
}

export class Load implements Action {
  readonly type = InitAction.Load;
}

export type InitActionType = Load;
